import {
  CommonTrackingData,
  getCommonTrackingData,
  trackingModelIdSplitter,
  VwTrack,
  VwTrackingEvents,
} from '@volkswagen-onehub/vw-e-mobility-feature-app-commons';
import {
  TrackingEvent,
  TrackingFunctions,
} from '@volkswagen-onehub/whitelabel-e-mobility-commons';
import {NaturalLanguageTrackingCtx} from '@volkswagen-onehub/whitelabel-e-mobility-natural-language-feature-app';

const getCommonData = ({
  selectedModel,
  selectedTrim,
  formState,
  tenantConfiguration,
}: NaturalLanguageTrackingCtx): CommonTrackingData => {
  const [trackingModelId, trackingModelTrimFeatures] = trackingModelIdSplitter(
    selectedModel.id
  );

  const selectedRimId = formState.rim;
  const selectedTireType = formState.tireType;

  return getCommonTrackingData(!!tenantConfiguration.global?.commercial, {
    EquipmentlineName: selectedTrim.trimId,
    CarlineId: selectedModel.carlineId,
    CarlineName: selectedModel.carlineName,
    SalesgroupId: selectedModel.salesgroupId,
    SalesgroupName: selectedModel.salesgroupName,
    ModelId: trackingModelId,
    ModelTrimFeatures: trackingModelTrimFeatures,
    ModelName: selectedModel.name,
    EnginePowerHPKW: selectedModel.engine,
    WheelsBasicSize:
      selectedModel.simulationConstants.rims[selectedRimId]?.['size-inch'],
    WheelsBasicType: selectedTireType,
  });
};

export function getNaturalLanguageTrackingFunctions(
  track: VwTrack
): TrackingFunctions<NaturalLanguageTrackingCtx> {
  return {
    [TrackingEvent.FeatureAppLoaded]: (_, ctx) =>
      track(
        VwTrackingEvents.VWBasic_eMobilityTools_Load,
        getCommonData(ctx),
        undefined
      ),
    [TrackingEvent.OutsideTemperatureChange]: ({temperatureCelsius}, ctx) =>
      track(VwTrackingEvents.VWBasic_FilterSelect_Click, getCommonData(ctx), {
        filter: {
          type: 'single_value',
          values: [temperatureCelsius],
          name: 'outside-temperature',
        },
      }),
    [TrackingEvent.DrivingProfileChange]: ({locationPercentages}, ctx) =>
      track(VwTrackingEvents.VWBasic_FilterSelect_Click, getCommonData(ctx), {
        filter: {
          type: 'multi_value',
          values: locationPercentages,
          name: 'driving-profile',
        },
      }),
    [TrackingEvent.PayloadPeopleChange]: ({value}, ctx) =>
      track(VwTrackingEvents.VWBasic_FilterSelect_Click, getCommonData(ctx), {
        filter: {
          type: 'single_value',
          values: [value],
          name: 'payload-passengers',
        },
      }),
    [TrackingEvent.ExactPayloadChange]: ({payloadKg}, ctx) =>
      track(VwTrackingEvents.VWBasic_FilterSelect_Click, getCommonData(ctx), {
        filter: {
          type: 'single_value',
          values: [payloadKg],
          name: 'payload-weight',
        },
      }),
    [TrackingEvent.RangeTrimSelect]: ({trim, model, tireType, rim}, ctx) => {
      const [trackingModelId, trackingModelTrimFeatures] =
        trackingModelIdSplitter(model.id);
      track(VwTrackingEvents.VWBasic_VehicleSelect_Click, getCommonData(ctx), {
        configuration: {
          // We need to overwrite all this from the common data with the new values.
          EquipmentlineName: trim.trimId,
          CarlineId: model.carlineId,
          CarlineName: model.carlineName,
          SalesgroupId: model.salesgroupId,
          SalesgroupName: model.salesgroupName,
          ModelId: trackingModelId,
          ModelTrimFeatures: trackingModelTrimFeatures,
          ModelName: model.name,
          EnginePowerHPKW: model.engine,
          WheelsBasicType: tireType,
          WheelsBasicSize: rim['size-inch'],
        },
      });
    },
  };
}
